// src/hooks/useTestimonials.js
import { getData, postData, updateData, deleteData } from "../services/apiService";

// Get all testimonials
export const fetchTestimonials = () => getData("/testimonials");

// Get all testimonials
export const fetchTestimonialsDashboard = () => getData("/testimonials/dashbaord");

// Get single testimonial by ID
export const fetchTestimonialById = (id) => getData(`/testimonials/${id}`);

// Get featured testimonials
export const fetchFeatureTestimonials = () => getData("/testimonials/feature");

// Create testimonial (with single image)
export const createTestimonial = (formData) => postData("/testimonial", formData, true);

// Update testimonial (with single image)
export const editTestimonial = (id, formData) => updateData(`/testimonials/${id}`, formData, true);

// Delete single testimonial
export const removeTestimonial = (id) => deleteData(`/testimonial/${id}`);
